import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../tooltip/style';
